import type { IntlShape } from 'react-intl';

type GenerateBreadcrumbsProps = {
  intl: IntlShape;
  pathname: string;
  contentTitle: string;
  dynamicSegments?: Record<string, string>;
};

export const generateBreadcrumbs = ({
  intl,
  pathname,
  contentTitle,
  dynamicSegments = {},
}: GenerateBreadcrumbsProps) => {
  const pathnames = pathname.split('/').filter(Boolean);

  return pathnames.map((path, index) => {
    const href = `/${pathnames.slice(0, index + 1).join('/')}`;
    const isLast = index === pathnames.length - 1;

    // Check if this segment has a dynamic replacement
    if (dynamicSegments[path]) {
      return {
        title: dynamicSegments[path],
        href: isLast ? undefined : href,
      };
    }

    // Try to get translation
    let title: string;
    try {
      title = intl.formatMessage({ id: `breadcrumb.${path}` });
    } catch {
      // If translation not found, use contentTitle for last segment, otherwise use the path
      title = isLast ? contentTitle : path;
    }

    // For the last segment, use contentTitle (which may be more specific than the translation)
    // For example, "PDF Preview" for PDF routes, or the workout name for workout routes
    return {
      title: isLast ? contentTitle : title,
      href: isLast ? undefined : href,
    };
  });
};
